import { createFileRoute } from '@tanstack/react-router';
import { PersonalInformationPage } from '../components/auth/PersonalInformationPage';

export const Route = createFileRoute('/personal-information')({
  component: PersonalInformation,
});

function PersonalInformation() {
  return <PersonalInformationPage />;
}
